var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{class:'cell elevation-4 '+_vm.cellColor,on:{"click":function($event){$event.stopPropagation();_vm.$emit('reveal', _vm.word)}}},[_c('span',{staticClass:"word"},[_vm._v(_vm._s(_vm.word))])])}
var staticRenderFns = []

export { render, staticRenderFns }